import { NavLink, useParams } from "react-router-dom";

export const GnbMenuItem = ({active=false, path="/", useable=true, onClick=f=>f, children})=>{
    const { school } = useParams();
    if( !useable ) return null;
    return (
        <li>
            <NavLink to={`/${school}${path}`} onClick={onClick} >
                {children}
            </NavLink>
        </li>
    );
};